<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações do PDV</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()"><mat-icon>arrow_back</mat-icon></button>
          Preferências gerais que valem para todo o módulo de vendas no PDV.
        </p>
      </div>
    </div>

    @if (isLoading) {
    <!-- Seção 1 — Parâmetros Gerais -->
    <div class="section-container">
      <app-loading-box height="28" width="220" marginTop="0"></app-loading-box>
      <div class="row mt-3">
        <div class="col-12 col-md-6"><app-loading-box height="56" width="100%" marginTop="8"></app-loading-box></div>
        <div class="col-12 col-md-6"><app-loading-box height="56" width="100%" marginTop="8"></app-loading-box></div>
        <div class="col-12 col-md-6"><app-loading-box height="56" width="100%" marginTop="8"></app-loading-box></div>
        <div class="col-12 col-md-6"><app-loading-box height="56" width="100%" marginTop="8"></app-loading-box></div>
        <div class="col-12">
          <app-loading-box height="18" width="320" marginTop="8"></app-loading-box>
          <app-loading-box height="18" width="180" marginTop="10"></app-loading-box>
          <app-loading-box height="18" width="180" marginTop="8"></app-loading-box>
        </div>
        <div class="col-12 col-md-6"><app-loading-box height="56" width="100%" marginTop="8"></app-loading-box></div>
      </div>
    </div>

    <!-- Seção 2 — Fechamento de Venda -->
    <div class="section-container mt-4">
      <app-loading-box height="28" width="220" marginTop="0"></app-loading-box>
      <div class="mt-3">
        @for (_ of skeletonTogglesSecao2; track $index) {
        <app-loading-box height="22" width="58%" marginTop="14"></app-loading-box>
        <app-loading-box height="14" width="40%" marginTop="6"></app-loading-box>
        }
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-6"><app-loading-box height="56" width="100%" marginTop="8"></app-loading-box></div>
        <div class="col-12 col-md-6"><app-loading-box height="56" width="100%" marginTop="8"></app-loading-box></div>
        <div class="col-12 col-md-4"><app-loading-box height="56" width="100%" marginTop="8"></app-loading-box></div>
      </div>
      <app-loading-box height="40" width="100%" marginTop="16"></app-loading-box>
    </div>

    <!-- Seção 3 — Fechamento de Caixa -->
    <div class="section-container mt-4">
      <app-loading-box height="28" width="220" marginTop="0"></app-loading-box>
      <div class="mt-3">
        @for (_ of skeletonTogglesSecao3; track $index) {
        <app-loading-box height="22" width="55%" marginTop="14"></app-loading-box>
        <app-loading-box height="14" width="38%" marginTop="6"></app-loading-box>
        }
      </div>
    </div>

    <!-- Seção 4 — Integração com Balança -->
    <div class="section-container mt-4">
      <app-loading-box height="28" width="220" marginTop="0"></app-loading-box>
      <app-loading-box height="20" width="42%" marginTop="16"></app-loading-box>
      <app-loading-box height="20" width="36%" marginTop="10"></app-loading-box>
    </div>

    <!-- Seção 5 — Modo Auto Atendimento -->
    <div class="section-container mt-4">
      <app-loading-box height="28" width="220" marginTop="0"></app-loading-box>
      <app-loading-box height="22" width="50%" marginTop="16"></app-loading-box>
      <app-loading-box height="14" width="35%" marginTop="6"></app-loading-box>
      <div class="row mt-3">
        <div class="col-12 col-md-6"><app-loading-box height="56" width="100%"></app-loading-box></div>
      </div>
    </div>
    } @else {
    <form [formGroup]="form">

      <!-- Seção 1 — Parâmetros Gerais -->
      <div class="section-container">
        <div class="section-title">
          <mat-icon>tune</mat-icon>
          <span>Parâmetros Gerais</span>
        </div>

        <div class="row mt-3">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Etapa padrão para vendas finalizadas</mat-label>
              <mat-select formControlName="idEtapaKanbanPadraoVenda">
                <mat-option [value]="null">Selecione</mat-option>
                @for (s of opcoesEtapaVenda; track s.idEtapaKanban) {
                <mat-option [value]="s.idEtapaKanban">{{ s.nome }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="hint-text">Recomenda-se Faturado ou Entregue.</div>
          </div>

          <div class="col-12 col-md-6">
            <app-select-pesquisavel
              [control]="tagsControl"
              label="Tag padrão para vendas"
              [offlineList]="opcoesTags"
              idField="idTagVenda"
              nameField="descricao"
              corField="cor"
              [multiple]="true"
              [showBadges]="true"
              subscriptSizing="dynamic">
            </app-select-pesquisavel>
          </div>

          <div class="col-12 col-md-6">
            <app-select-pesquisavel
              [control]="listaPrecoControl"
              label="Lista de preço preferencial"
              [offlineList]="opcoesListaPreco"
              idField="id"
              nameField="descricao"
              [isOptional]="true">
            </app-select-pesquisavel>
            <div class="hint-text">Se vazio, o PDV usa o preço padrão do produto. O operador pode alterar durante o atendimento.</div>
          </div>

          <div class="col-12 col-md-6">
            <app-select-pesquisavel
              [control]="naturezaOperacaoControl"
              label="Natureza de operação padrão para NFC-e"
              [apiUrl]="naturezaOperacaoApiUrl"
              [extraParams]="naturezaOperacaoExtraParams"
              [preloadedOptions]="naturezaOperacaoPreload"
              idField="id"
              nameField="descricao"
              [isOptional]="true">
            </app-select-pesquisavel>
          </div>

          <div class="col-12 mb-3">
            <label class="font-weight-bold d-block mb-2">
              Bloquear emissão de vendas com estoques que não podem ser atendidos
            </label>
            <mat-radio-group formControlName="bloquearVendaSemEstoque" class="d-flex flex-column" style="gap: 8px">
              <mat-radio-button [value]="false">
                Não <span class="opcao-desc">— Permite venda mesmo sem estoque (gera estoque negativo).</span>
              </mat-radio-button>
              <mat-radio-button [value]="true">
                Sim <span class="opcao-desc">— Bloqueia a venda de itens sem saldo disponível.</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="col-12 col-md-6">
            <app-select-pesquisavel
              [control]="localizacaoControl"
              label="Depósito padrão para lançamento de estoque"
              [offlineList]="opcoesLocalizacao"
              idField="id"
              nameField="descricao"
              [isOptional]="true">
            </app-select-pesquisavel>
            <div class="hint-text">O operador pode alterar no momento do fechamento da venda.</div>
          </div>
        </div>
      </div>

      <!-- Seção 2 — Fechamento de Venda -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>shopping_cart_checkout</mat-icon>
          <span>Fechamento de Venda</span>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="vendedorObrigatorio">Vendedor
                obrigatório</mat-slide-toggle>
              <span class="info-text">Exige a seleção de um vendedor antes de concluir a venda.</span>
            </div>
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="bloquearVendaValorInferior">Bloquear vendas
                com total recebido inferior ao total da venda</mat-slide-toggle>
              <span class="info-text">Impede o fechamento quando o valor pago é menor que o total.</span>
            </div>
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="permitirVendaProdutoNaoCadastrado">Permitir
                a venda de produtos não cadastrados</mat-slide-toggle>
              <span class="info-text">Libera inclusão de itens não cadastrados durante a venda.</span>
            </div>
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="bloquearAlteracaoPreco">Bloquear alteração
                de preço unitário do item</mat-slide-toggle>
              <span class="info-text">Impede que o operador altere o preço de venda no pagamento.</span>
            </div>
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="agrupamentoAutomatico">Agrupamento
                automático de produtos iguais</mat-slide-toggle>
              <span class="info-text">Consolida itens iguais em uma única linha (ex: 3× Produto A).</span>
            </div>
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="mostrarTelaRecebimento">Mostrar tela com
                formas de recebimento</mat-slide-toggle>
              <span class="info-text">Exibe tela de registro de pagamento antes de finalizar a venda.</span>
            </div>
          </div>

          <div class="col-12 col-md-6 mt-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipo de nota fiscal padrão no fechamento</mat-label>
              <mat-select formControlName="isEmissaoAutomaticaNFCe">
                <mat-option [value]="true">Emitir automaticamente a NFC-e</mat-option>
                <mat-option [value]="false">Permitir a emissão de NF-e</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-6 mt-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Impressão automática ao finalizar venda</mat-label>
              <mat-select formControlName="listIdTipoImpressao" multiple>
                @for (i of opcoesTipoImpressao; track i.idTipoImpressaoPdv) {
                <mat-option [value]="i.idTipoImpressaoPdv">{{ i.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if ((form.get('listIdTipoImpressao')?.value || []).length === 0) {
            <div class="hint-text">Nenhuma opção selecionada — nenhuma impressão será realizada.</div>
            } @else {
            <div class="hint-text">Requer contrato ativo com PrintNode configurado na conta.</div>
            }
          </div>

          <div class="col-12 col-md-4 mt-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Desconto máximo nos itens</mat-label>
              <input matInput currencyMask [options]="percentMask" formControlName="descontoMaximoItens">
              <span matTextSuffix>%</span>
              @if (form.get('descontoMaximoItens')?.hasError('min') || form.get('descontoMaximoItens')?.hasError('max'))
              {
              <mat-error>Informe um valor entre 0 e 100.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-12 mt-2">
            <app-desconto-maximo-perfil [perfis]="opcoesPerfis" [value]="descontoPerfil"
              (valueChange)="onDescontoPerfilChange($event)">
            </app-desconto-maximo-perfil>
          </div>
        </div>
      </div>

      <!-- Seção 3 — Fechamento de Caixa -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>point_of_sale</mat-icon>
          <span>Fechamento de Caixa</span>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="controlarCaixa">Controlar abertura e
                fechamento de caixa</mat-slide-toggle>
              <span class="info-text">Toggle mestre — quando ativo, os controles abaixo ficam habilitados.</span>
            </div>

            <div class="toggle-content" [class.toggle-disabled]="!form.get('controlarCaixa')?.value">
              <mat-slide-toggle class="app-toggle-compact"
                formControlName="considerarRecebimentosFaturarPrevenda">Considerar recebimentos do "faturar pré-venda"
                para fechamento de caixa</mat-slide-toggle>
              <span class="info-text">Inclui no fechamento recebimentos de pedidos faturados como pré-venda.</span>
            </div>
            <div class="toggle-content" [class.toggle-disabled]="!form.get('controlarCaixa')?.value">
              <mat-slide-toggle class="app-toggle-compact" formControlName="permitirCompartilhamentoCaixa">Permitir
                compartilhamento de caixa entre usuários</mat-slide-toggle>
              <span class="info-text">Mais de um vendedor pode usar o mesmo caixa.</span>
            </div>
            <div class="toggle-content" [class.toggle-disabled]="!form.get('controlarCaixa')?.value">
              <mat-slide-toggle class="app-toggle-compact" formControlName="exibirValoresFormasRecebimento">Exibir
                valores de cada forma de recebimento no fechamento de caixa</mat-slide-toggle>
              <span class="info-text">Mostra totais por forma de pagamento; divergências aparecem no comprovante.</span>
            </div>
            <div class="toggle-content" [class.toggle-disabled]="!form.get('controlarCaixa')?.value">
              <mat-slide-toggle class="app-toggle-compact" formControlName="aberturaCaixaUltimoValor">Realizar abertura
                de caixa com último valor de fechamento</mat-slide-toggle>
              <span class="info-text">Preenche automaticamente o saldo inicial com o valor do fechamento
                anterior.</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção 4 — Integração com Balança -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>scale</mat-icon>
          <span>Integração com Balança</span>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <label class="font-weight-bold d-block mb-2">Composição do código de barras gerado na balança</label>
            <mat-radio-group formControlName="idTipoComposicaoCodigoBarras" class="d-flex flex-column" style="gap: 8px">
              @for (tc of opcoesTipoComposicao; track tc.idTipoComposicaoCodigoBarras) {
              <mat-radio-button [value]="tc.idTipoComposicaoCodigoBarras">{{ tc.descricao }}</mat-radio-button>
              }
            </mat-radio-group>
          </div>
        </div>
      </div>

      <!-- Seção 5 — Modo Auto Atendimento -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>person</mat-icon>
          <span>Modo Auto Atendimento</span>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="permitirAutoAtendimento">Permitir modo de
                auto atendimento</mat-slide-toggle>
              <span class="info-text">Habilita o PDV para operação autônoma pelo cliente (self-service).</span>
            </div>
          </div>

          <div class="col-12 col-md-6 mt-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Perfis autorizados a alternar para o modo de venda normal</mat-label>
              <mat-select formControlName="listIdPerfilAutoatendimento" multiple>
                @for (p of opcoesPerfis; track p.idPerfil) {
                <mat-option [value]="p.idPerfil">{{ p.nome }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (form.get('permitirAutoAtendimento')?.value && (form.get('listIdPerfilAutoatendimento')?.value ||
            []).length === 0) {
            <div class="hint-text">Nenhum perfil selecionado — somente administradores poderão alternar o modo.</div>
            }
          </div>
        </div>
      </div>

    </form>
    }
  </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
  (salvar)="salvar()">
</app-footer-action>